import type { IconProps } from './types';
import './icons.css';

export default function Hint({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-hint ${className || ''}`}
    >
      <path
        fill="currentColor"
        d="M7.084 9.8H8.46v-.11c.009-.898.294-1.309.969-1.732.76-.466 1.237-1.102 1.237-2.072 0-1.432-1.088-2.33-2.669-2.33-1.448 0-2.623.821-2.665 2.431h1.473c.038-.796.6-1.177 1.184-1.177.633 0 1.142.432 1.142 1.097 0 .593-.385 1-.886 1.322-.732.466-1.154.936-1.162 2.461v.11zm.724 2.644c.488 0 .906-.415.91-.932a.93.93 0 0 0-.91-.923.914.914 0 0 0-.91.923.916.916 0 0 0 .91.932z"
      />
      <rect
        fill="transparent"
        stroke="currentColor"
        width="15"
        height="15"
        x=".5"
        y=".5"
        rx="7.5"
      />
    </svg>
  );
}
